<template>
  <div :id="id" class="progressGroup" :style="wrap">
    <div class="left">
      <div class="name" v-for="(ind, item) in listDataSort" :key="ind">
        <div class="num">
          {{ ind + 1 }}
        </div>
        <div class="nametext">
          {{ item[name] }}
        </div>
      </div>
    </div>
    <div class="right">
      <div class="progress" v-for="(ind, item) in listDataSort" :key="ind">
        <div
          class="progressBar"
          :style="{ background: color, width: widthComputed[ind] }"
        ></div>
        <div class="number">
          {{ item[value] }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const component = {
  name: "hex-chart",
  props: {
    id: String,
    st: Object,
    listdata: {
      default: [
        {
          name: "北京",
          val: "80"
        },
        {
          name: "上海",
          val: "100"
        },
        {
          name: "广州",
          val: "60"
        }
      ]
    },
    list: [Array, Object],
    mockData: [Array, Object],
    name: String,
    value: String,
    color: String,
    max: String,
    sort_rule: String,
    value_rule: String
  },
  computed: {
    wrap() {
      let final = JSON.parse(JSON.stringify(this.st));
      return process.env.MODE === "editor" ? final : "";
    },
    changeValueRule() {
      let arr = JSON.parse(JSON.stringify(this.listdata));
      let map = {};
      let change = [];
      switch (this.value_rule) {
        case "count":
          // 计数代表的是出现的次数
          arr.map(item => {
            if (map[item[this.name]]) {
              map[item[this.name]]++;
            } else {
              map[item[this.name]] = 1;
            }
          });
          Object.keys(map).map(item => {
            let obj = {};
            obj[this.name] = item;
            obj[this.value] = map[item];
            change.push(obj);
          });
          return change;
        case "sum":
          // 求和代表的是所有数值累计
          arr.map(item => {
            if (map[item[this.name]]) {
              map[item[this.name]] += item[this.value]*1;
            } else {
              map[item[this.name]] = item[this.value]*1;
            }
          });
          Object.keys(map).map(item => {
            let obj = {};
            obj[this.name] = item;
            obj[this.value] = map[item];
            change.push(obj);
          });
          return change;
        case "average":
          // 平均值相当于累计/出现的次数
          arr.map(item => {
            if (map[item[this.name]]) {
              map[item[this.name]].total += item[this.value]*1;
              map[item[this.name]].num ++ ;
            } else {
              map[item[this.name]] = {
                total: item[this.value]*1,
                num: 1
              }
            }
          });
          Object.keys(map).map(item => {
            let obj = {};
            obj[this.name] = item;
            obj[this.value] = (map[item].total/map[item].num).toFixed(2);
            change.push(obj);
          });
          return change;
      }
      return arr;
    },
    listDataSort() {
      let arr = JSON.parse(JSON.stringify(this.changeValueRule));
      switch (this.sort_rule) {
        case "up":
          return arr.sort((a, b) => {
            return a[this.value] - b[this.value];
          });
          break;
        case "down":
          return arr.sort((a, b) => {
            return b[this.value] - a[this.value];
          });
          break;
        default:
          return arr;
      }
    },
    finalMax() {
      if (this.max * 1) {
        return this.max * 1;
      }
      let max = 0;
      this.listDataSort.map(item => {
        if (item[this.value] * 1 > max) {
          max = item[this.value] * 1;
        }
      });
      return max;
    },
    widthComputed: function() {
      let widthArr = [];
      let pointer = 0;
      this.listDataSort.map(item => {
        pointer = (item[this.value] / this.finalMax) * 75;
        if (pointer > 75) {
          widthArr.push("75%");
        } else {
          widthArr.push(pointer + "%");
        }
      });
      return widthArr;
    }
  },
  ready() {}
};
// 区分editor和实际打包， build之后的lib不打包
if (process.env.MODE === "editor") {
  component.define = require("./define");
}
export default component;
</script>

<style lang="less" scoped>
/* 进度条组 */
.progressGroup {
  box-sizing: border-box;
  line-height: 18px;
  font-size: 14px;
  padding: 16px;
  display: flex;
  background: #000;
  .left {
    width: max-content;
    flex-shrink: 0;
    max-width: 33%;
    .name {
      color: #b6b6b6;
      margin-right: 16px;
      display: flex;
      justify-content: space-between;
      max-width: 100%;
      .num {
        margin-right: 4px;
      }
      .nametext {
        white-space: nowrap;
        overflow: hidden;
        word-break: keep-all;
        text-overflow: ellipsis;
      }
    }
  }
  .right {
    flex-grow: 1;
    .progress {
      flex-shrink: 0;
      display: flex;
      flex-grow: 1;
      .progressBar {
        height: 6px;
        margin-top: 6px;
        border-radius: 2px;
      }
      .number {
        color: #fff;
        margin-left: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?0d440d09